import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { useCheckFeatureFlag } from "@/shared/domain/featureFlags/hooks/useCheckFeatureFlag";

import { type DeviceTypeRecord } from "../DeviceTypeRecord";

import { deviceTypeQueryKeys } from "./deviceTypeQueryKeys";

/**
 * Every device type in an org. Sends no request while `release-asset-store` is
 * off for the org, since the route would answer 403.
 */
export function useAllDeviceTypesByOrg(orgId: string | undefined) {
  const { deviceTypes } = useDomainServices();
  const assetStoreEnabled = useCheckFeatureFlag("release-asset-store", orgId);

  return useQuery<DeviceTypeRecord[], Error>({
    queryKey: deviceTypeQueryKeys.list(orgId),
    queryFn: ({ signal }) => {
      if (orgId === undefined) {
        return Promise.reject(new Error("Invalid orgId"));
      }
      return deviceTypes.getAllDeviceTypesByOrg(orgId, { abortSignal: signal });
    },
    enabled: orgId !== undefined && assetStoreEnabled,
  });
}
